<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2"><h3 class="content-header-title mb-0">Gallery</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a></li>
                            <li class="breadcrumb-item active">Gallery</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <div class="row">
                <div class="col-md-2">
                    <div class="folders">
                        <div class="folders--header"><h4>Folders</h4>
                            <a href="#" title="add folder"
                               @click="addFolderShow = !addFolderShow; selectedFolder = null">
                                <i class="feather icon-plus"></i></a></div>
                        <div class="folders--body">
                            <div class="folder" v-if="addFolderShow">
                                <input @keyup.enter="addFolder" v-model="folder.folder_name"
                                       placeholder="Folder Name"/></div>
                            <div class="folder" @click="folderClickHandler('')"><span class="folder--icon"></span>
                                <i class="feather icon-folder"></i><span class="folder--name">All</span>
                                <span class="folder--item-count">{{ defaultImages.length }}</span>
                            </div>
<!--                            <div class="folder" @click="folderClickHandler('')"><span-->
<!--                                class="folder&#45;&#45;icon"></span>-->
<!--                                <i class="feather icon-folder"></i><span class="folder&#45;&#45;name">Uncategorized</span> <span-->
<!--                                    class="folder&#45;&#45;item-count">{{ uncategorized.length }}</span>-->
<!--                            </div>-->
                            <div v-for="folder in folders" :key="folder.id">
                                <div class="folder" @click="folderClickHandler(folder)"
                                     @contextmenu.prevent.stop="showMenu(folder, $event)">
                                    <i class="feather icon-folder"></i>
                                    <span class="folder--name">{{ folder.folder_name }}</span> <span
                                    class="folder--item-count">{{
                                        (folder.subfolders ? folder.subfolders.length : 0) + folder.galleries.length
                                    }}</span>
                                    <i class="feather" :class="{'icon-chevron-right': folder.subfolders}"></i></div>
                                <div class="folder sub-folder" @click="folderClickHandler(subfolder)"
                                     v-for="subfolder in folder.subfolders" :key="subfolder.id"
                                     @contextmenu.prevent.stop="showMenu(subfolder, $event)"><span
                                    class="folder--icon"></span> <span
                                    class="folder--name">{{ subfolder.folder_name }}</span> <span
                                    class="folder--item-count">{{ folder.galleries.length }}</span> <i
                                    class="feather"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-10">
                    <section id="image-grid" class="card">
                        <div class="card-header"><h4 class="card-title">
                            {{ selectedFolder ? selectedFolder.folder_name : '' }}</h4> <a
                            class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"></i></a>
                            <div class="heading-elements">
                                <ul class="list-inline mb-0">
                                    <li><a data-action="collapse"><i class="feather icon-minus"></i></a></li>
                                    <li><a data-action="reload"><i class="feather icon-rotate-cw"></i></a></li>
                                    <li><a data-action="expand"><i class="feather icon-maximize"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content collapse show">
                            <div class="card-body my-gallery">
                                <template v-if="selectedFolder">
                                    <form action="">
                                        <file-pond name="test" ref="pond" label-idle="Drop files here..."
                                                   :allow-multiple="true" accepted-file-types="image/jpeg, image/png"
                                                   :files="images" @init="handleFilePondInit"/>
                                        <button class="btn btn-primary btn-sm" type="button" @click="addImage">Submit
                                        </button>
                                    </form>
                                </template>

                                <div class="card-body my-gallery">
                                    <div class="row">
                                        <template></template>
                                        <figure class="col-lg-3 col-md-6 col-12" v-for="image in allImages"
                                                :key="image.id">
                                            <a :href="image.image" target="_blank"> <img
                                                class="img-thumbnail img-fluid" :src="image.image_thumbnail"
                                                itemprop="thumbnail" alt="Image description"> </a>
                                            <br>
                                            <a class="text-danger" href="#" @click="showAlert(image.id)">
                                                <i class="feather icon-trash"></i>
                                            </a>
                                        </figure>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>

<!--        <div v-click-outside="closeMenu" class="context-menu" v-if="toggleMenu"-->
<!--             :style="{'top': mouseCoords.clientY + 'px', 'left': mouseCoords.clientX + 'px'}">-->
<!--            <ul>-->
<!--                <li @click="addFolderShow = true; toggleMenu = false" v-if="!selectedFolder.is_sub_folder"><i-->
<!--                    class="feather icon-folder-plus"></i> New Folder-->
<!--                </li>-->
<!--                <li><i class="feather icon-file-text"></i> Rename</li>-->
<!--                <li><i class="feather icon-delete"></i> Delete</li>-->
<!--            </ul>-->
<!--        </div>-->
    </div>
</template>
<script>
import vueFilePond from 'vue-filepond';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import Layout from '@/Shared/Layout';
import axios from 'axios';
import DeleteAlert from "../../Shared/Mixins/DeleteAlert";
import PaginationMixin from "../../Shared/Mixins/PaginationMixin";

const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview)
export default {
    components: {FilePond},
    mixins: [
        DeleteAlert,
    ],
    props: ['dataFolders', 'dataAllImages'],
    layout: Layout,
    data: () => ({
        images: [],
        category: '',
        addFolderShow: false,
        folder: {},
        folders: [],
        selectedFolder: null,
        mouseCoords: {clientX: 0, clientY: 0},
        toggleMenu: true,
        allImages: [],
        // uncategorized: [],
        defaultImages: []
    }),
    created() {
        this.folders = this.dataFolders;
        this.allImages = this.dataAllImages;
        this.defaultImages = this.allImages;
        // this.uncategorized = this.allImages.filter(image => !image.gallery_folder_id);
    },
    methods: {
        async addFolder() {
            let folderData = this.folder;
            if (this.selectedFolder) {
                folderData.is_sub_folder = 1;
                folderData.top_folder_id = this.selectedFolder.id;
            }
            try {
                const {data: {data, message}} = await axios.post(route('admin.galleries.create-folder'), folderData);
                console.log(data);
                this.folder = {};
                this.addFolderShow = false;
                this.selectedFolder = null;
                this.folders = data;
                alert('Folder Created!')
            } catch (error) {
                console.log(error);
                alert('Folder not Created, try again')
            }
        },
        showMenu(folder, event) {
            this.toggleMenu = true;
            this.selectedFolder = folder;
            this.mouseCoords.clientX = event.clientX;
            this.mouseCoords.clientY = event.clientY - 70;
        },
        folderClickHandler(folder) {
            if (folder === undefined) {
                this.allImages = this.uncategorized;
                return;
            } else if (folder === '') {
                this.allImages = this.defaultImages;
                return;
            }
            this.selectedFolder = folder;
            this.allImages = folder.galleries;
        },
        async addImage() {
            const uploadedFiles = this.$refs.pond.getFiles();
            if (uploadedFiles.length > 0) {
                const formData = new FormData();
                uploadedFiles.forEach(upf => formData.append('images[]', upf.file));
                formData.append('folder_id', this.selectedFolder ? this.selectedFolder.id : '');
                try {
                    await axios.post(route('admin.galleries.store'), formData);
                    location.reload();
                } catch (e) {
                    console.log(e);
                }
            }
        },
        handleFilePondInit: function () {
            console.log('FilePond has initialized');
        },
        closeMenu() {
            this.toggleMenu = false;
            this.selectedFolder = {};
        },
        async deleteImage(id) {
            this.$inertia.delete(route('admin.galleries.delete', id), {
                preserveScroll: true,
                onSuccess: () => {
                    location.reload();
                }
            })
        },
        async showAlert(imageId) {
            const details = {
                title: "Are you sure you want to delete this Image?",
                text: "You won't be able to revert this!",
            }
            await this.deleteAlert(details.title, details.text) ? await this.deleteImage(imageId) : "";
        },
    }, computed: {}
}
</script>

<style scoped>
.folder--name {
    flex: 1;
    font-weight: 600;
    text-transform: capitalize;
}

.folder {
    margin: 7px 0;
    display: flex;
    cursor: pointer;
    align-items: center;
}

.folder--name {
    flex: 1;
    font-weight: 600;
    text-transform: capitalize;
}
</style>
